module.exports = __webpack_public_path__ + "img/29.0fc76987.jpg";